/************
 Product Swiper
 ************/

// setup product swiper
let productImages = new Swiper("#productSwiper", {
    navigation: {
        nextEl: '#product .productControlsNext',
        prevEl: '#product .productControlsPrev',
    },
});

// thumbnail
document.querySelectorAll(".productThumbnail").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productImages.slideTo(index);
    });
});

/****************
 * Product Quantity
 */

let quantity = 1;

// minus
document.querySelector("#productQuantityMinus").addEventListener("click", function () {
    // must not be less than 1
    if (quantity === 1) {
        return;
    }

    // decrement by 1
    quantity--;
    document.querySelector("#productQuantityValue").textContent = quantity;
});

// plus
document.querySelector("#productQuantityPlus").addEventListener("click", function () {
    // increment by 1
    quantity++;
    document.querySelector("#productQuantityValue").textContent = quantity;
});

/**************
 Product ATC
 ***************/

document.querySelector("#productATC").addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    let formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id
        }]
    };

    // check for selling plan
    if (document.querySelector("#productVariantSubscription:checked")) {
        formData.items[0].selling_plan = product.selling_plan_groups[0].selling_plans[0].id;
    }

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    window.location.href = "/cart";
});

/**************
 Accordion Dropdown
 ***************/

document.querySelectorAll('.productAccordionTop').forEach((el) => {
    let parent = el.closest('.productAccordion')
    el.addEventListener('click', function () {

        if (this.classList.contains('open')) {
            parent.querySelector('.productAccordionList').classList.remove('open')
            this.classList.remove('open')
        } else {
            parent.querySelector('.productAccordionList').classList.add('open')
            this.classList.add('open')
        }
    })
})

/**************
 Variant Select
 ***************/

document.querySelectorAll('.productVariant').forEach((el) => {
    el.addEventListener('click', function () {
        this.closest('#productForm').querySelector('.active').classList.remove('active');
        this.classList.add('active');
    })
});